import { blotterColumnStateToGridState, type BlotterTableStateV2 } from '@talos/kyoko';
import type { AppConfigState } from '../AppConfigProvider.types';

/**
 * Migrate `blotters2`'s persisted column model into `blotters3`'s nested grid-state model.
 * Existing `blotters3` entries are preserved, and `blotters2` is left untouched.
 */
export function migrateBlotters2ToBlotters3(config: {
  blotters2?: BlotterTableStateV2;
  blotters3?: AppConfigState['blotters3'];
}) {
  if (config.blotters2 == null || config.blotters3 != null) {
    return;
  }

  config.blotters3 = {};

  for (const [blotterId, blotterState] of Object.entries(config.blotters2)) {
    if (blotterState?.columns == null && blotterState.filter == null) {
      continue;
    }

    config.blotters3[blotterId] = {
      gridState: blotterState.columns ? blotterColumnStateToGridState(blotterState.columns) : undefined,
      filter: blotterState.filter,
    };
  }
}
